import { checksum } from "isbn-validation";

export default function(isbn, helper) {
  return (
    checksum((isbn || "").replace(/-| /g, "") || "") ||
    helper.message("validation-errors.{#label}-invalid")
  );
}
